import axios from "axios";
import { Toast } from "vant";
import {addTokenConfig, jumpToWeChatLogin} from "./wxLoginFun";
let getBaseUrl = "";
const host = window.location.host;

if (host.indexOf('paddl.test.classba.cn') > -1) { // 测试环境
  getBaseUrl = 'https://agent-api-test.classba.cn/agentmanageapplet';
} else if (host.indexOf('exp4pad-pre.classba.cn') > -1) { // 预发环境
  getBaseUrl = 'https://agent-api-pre.classba.cn/agentmanageapplet';
} else if (host.indexOf('exp4pad.classba.cn') > -1) { // 正式环境
  getBaseUrl = 'https://agent-api.classba.cn/agentmanageapplet';
} else {
  getBaseUrl = 'http://agent-api.zc.dev.myyixue.com/agentmanageapplet';
  // getBaseUrl = 'https://agent-api-test.classba.cn/agentmanageapplet';
  // getBaseUrl = 'https://agent-api.classba.cn/agentmanageapplet';
}


axios.defaults.withCredentials = false;
const service = axios.create({
  baseURL: getBaseUrl,
  withCredentials: false,
  timeout: 10 * 1000, // request timeout
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
  },
});
service.interceptors.request.use(
  function (config) {
    return Promise.resolve(config);
  },
  function (error) {
    Toast("系统开小差了，刷新后再试");
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  function (response) {
    if(jumpToWeChatLogin(response)) {
      let retData;
      if (response.data.code < 0) {
        retData = {
          ...response.data,
          //  message: '系统开小差了，刷新后再试'
        };
      } else {
        retData = {
          ...response.data,
        };
      }
      return Promise.resolve(retData);
    }
  },
  function (error) {
    Toast("系统开小差了，刷新后再试");
    return Promise.reject(error);
  }
);

class AccountAxios {
  constructor(options = {}) {
    this.options = options;
  }
  request(options) {
    return service.request(options);
  }
  get(url, options = {}) {
    return this.request({
      url: url,
      params: {
        ...options,
      },
    });
  }
  post(url, data, options = {}) {
    if (data instanceof Object) {
      data = JSON.stringify(data);
    }
    return this.request({
      method: "post",
      url,
      data,
      ...options,
    });
  }
}
const instanceAxios = new AccountAxios();
export const request = instanceAxios.request.bind(instanceAxios);
export const get = instanceAxios.get.bind(instanceAxios);
export const post = instanceAxios.post.bind(instanceAxios);
